module.exports = __webpack_public_path__ + "img/29.5f01ca17.jpg";